'use client';
import { ModalName, showModal } from '@/components/modals';

export function openRatingDriverModal(props?: { fullScreen?: boolean }) {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  showModal(
    ModalName.RatingDriver,
    {},
    {
      fullScreen: props?.fullScreen ?? isMobile,
      centered: true,
      withCloseButton: false,
      closeOnClickOutside: false,
      closeOnEscape: false,
      size: 'md',
      styles: {
        body: {
          padding: 0,
          background: 'white',
        },
        content: {
          overflow: 'hidden',
        },
      },
    }
  );
}
